<template>
  <div class="Card">
    <Miniload v-if="!$parent.markersReady" />
  </div>
</template>

<script>
import Miniload from '@/components/miniload/Miniload'

export default {
  name: 'Card',
  props: ['found'],
  components: { Miniload },
  watch: {
    'found': 'onFound',
    '$parent.phaserLoaded': 'onFound'
  },
  methods: {
    onFound() {
      if(!this.$parent.phaserLoaded) return false

      if(this.found) {
        TweenMax.set(this.$parent.$model_spritesheet, { three: {
          scale: 1.5,
          // y axis, positive verse le bas
          z: 2.6,
          // x axis, positive verse la droite
          x: 1.8
        }})
      }
    }
  }
}
</script>

